import { sharedEnvironment } from './shared.environment.js';

export const environment = {
	...sharedEnvironment,
	production: true,

	azureSearch: {
		endpoint: 'https://gymvio-search.search.windows.net',
		queryKey: 'mg0iRNIp6jGq0Hf8DSYcMPqiI8GNpYM30pcDgkiwNEAzSeBjSZKt',
		indexes: {
			foods: 'coachway-foods'
		}
	},
	app: {
		baseUrl: 'http://localhost:8080'
	},
	api: {
		serverBaseUrl: 'http://localhost:8080'
	},
	paddle: {
		isSandbox: false,
		sellerId: 50201,
		clientSideToken: 'live_5e3235c3542e72a81875378a7de',
		priceIds: {
			premium: 'pri_01hphzfcjyh7m0r9v4dp1ctvdq'
		}
	}
};
